import axios from "axios";
import { toast } from "sonner";
import { API } from "../../context/AppContext";

// Axios instance that always sends & receives the httpOnly admin cookie.
export const admin = axios.create({ baseURL: API, withCredentials: true });

export const LOW_STOCK_UI_THRESHOLD = 5;

export const filterBtn = (active) =>
  `px-3 py-2 font-mono text-[10px] tracking-[0.25em] uppercase border ${
    active ? "border-[color:var(--bl-gold)] text-[color:var(--bl-gold)]" : "border-white/15 text-white/60 hover:text-white"}`;

export const inputCls =
  "bg-transparent border border-white/15 focus:border-[color:var(--bl-blue)] outline-none text-white font-mono";

export async function downloadCsv(path, prefix, label) {
  try {
    const r = await admin.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([r.data], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `${prefix}-${new Date().toISOString().slice(0, 16).replace(/[:T]/g, "-")}.csv`;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
    toast.success(`Exported ${label}`);
  } catch { toast.error("Export failed"); }
}
